"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Integration_module_css_1 = __importDefault(require("../Integration.module.css"));
var react_i18next_1 = require("react-i18next");
var ManagementToolbar_1 = __importDefault(require("./ManagementToolbar"));
var inertia_1 = require("@inertiajs/inertia");
var IntegrationStatusTab_1 = __importDefault(require("./Status/IntegrationStatusTab"));
var IntegrationSettingsTab_1 = __importDefault(require("./Settings/IntegrationSettingsTab"));
var IntegrationState_1 = __importDefault(require("@/Helper/IntegrationState"));
var IntegrationManagement = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(props.integration ? "Integration status" : "Settings"), activeTab = _a[0], setActiveTab = _a[1];
    var _b = (0, react_1.useState)(props.integration), integrationData = _b[0], setIntegrationData = _b[1];
    var _c = (0, react_1.useState)(), jobState = _c[0], setJobState = _c[1];
    var handleTabChange = function (tab) { return setActiveTab(tab); };
    var handleBackToIntegrationsPage = function () { return inertia_1.Inertia.visit("/integrations"); };
    var handleIntegrationUpdate = function (updatedIntegration) {
        setIntegrationData(__assign({}, updatedIntegration));
    };
    var handleResourceDelete = function (identifier) {
        if (!integrationData)
            return;
        var updatedScripts = integrationData.definition.scripts
            ? __assign({}, integrationData.definition.scripts) : {};
        var updatedResources = integrationData.definition.resources
            ? __assign({}, integrationData.definition.resources) : {};
        if (identifier in updatedScripts) {
            delete updatedScripts[identifier];
        }
        if (identifier in updatedResources) {
            delete updatedResources[identifier];
        }
        var updatedIntegration = __assign(__assign({}, integrationData), { definition: __assign(__assign({}, integrationData.definition), { scripts: updatedScripts, resources: updatedResources }) });
        setIntegrationData(updatedIntegration);
    };
    (0, react_1.useEffect)(function () {
        if (!jobState && integrationData) {
            var state = new IntegrationState_1.default(integrationData);
            state.loadStatistics();
            state.loadAllScriptJobs();
            setJobState(state);
        }
    }, []);
    var IntegrationTabContent = function () {
        if (!props.integrationTemplate) {
            return react_1.default.createElement("p", null, "Loading...");
        }
        switch (activeTab) {
            case "Settings":
                return (react_1.default.createElement(IntegrationSettingsTab_1.default, { permissions: props.permissions, integrationTemplate: props.integrationTemplate, integration: integrationData, onIntegrationUpdate: handleIntegrationUpdate, onResourceDelete: handleResourceDelete }));
            case "Integration status":
            default:
                return (react_1.default.createElement(IntegrationStatusTab_1.default, { permissions: props.permissions, integrationTemplate: props.integrationTemplate, integration: integrationData, jobState: jobState }));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: Integration_module_css_1.default["toolbar-area"] },
            react_1.default.createElement("div", { className: Integration_module_css_1.default["back-button"], onClick: handleBackToIntegrationsPage, title: t("Back to developer page") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faArrowLeftFromLine, style: { marginRight: "8px" } })),
            react_1.default.createElement("div", { className: Integration_module_css_1.default["toolbar-center"] },
                react_1.default.createElement(ManagementToolbar_1.default, { activeTab: activeTab, integration: integrationData, onTabChange: handleTabChange }))),
        react_1.default.createElement("div", { className: "page-content-container" },
            react_1.default.createElement("div", { className: "page-content" },
                react_1.default.createElement(IntegrationTabContent, null)))));
};
exports.default = IntegrationManagement;
